module.exports = __webpack_public_path__ + "images/logo.4fe8163.png";